import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import '../App.css';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

function AdminDashboard() {
  const navigate = useNavigate();
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedCategory, setSelectedCategory] = useState('Toutes');

  const categories = [
    'Toutes',
    'Le Marketing de réseau et le NetWorking',
    'Les outils pour bien démarrer',
    'Découvrir les nouveaux MLM'
  ];

  useEffect(() => {
    // Check auth
    if (!sessionStorage.getItem('adminAuth')) {
      navigate('/admin');
      return;
    }
    
    fetchArticles();
  }, []);

  const fetchArticles = async () => {
    try {
      // Fetch all articles including inactive ones for admin view
      const response = await axios.get(`${API}/articles?admin=true`);
      setArticles(response.data);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching articles:', error);
      setLoading(false);
    }
  };

  const toggleArticleStatus = async (articleId, currentStatus) => {
    try {
      const response = await axios.patch(`${API}/articles/${articleId}/toggle-active`);
      alert(`✅ Article ${response.data.is_active ? 'activé' : 'désactivé'} avec succès !`);
      // Refresh articles list
      fetchArticles();
    } catch (error) {
      console.error('Error toggling article status:', error);
      alert('❌ Erreur lors du changement de statut');
    }
  };

  const handleLogout = () => {
    sessionStorage.removeItem('adminAuth');
    navigate('/admin');
  };

  const filteredArticles = selectedCategory === 'Toutes' 
    ? articles 
    : articles.filter(a => a.category === selectedCategory);

  return (
    <div className="app">
      <nav className="nav">
        <div className="nav-container">
          <div className="nav-logo">
            <span className="logo-text">AmsWeb Admin</span>
          </div>
          <div className="nav-links">
            <button onClick={() => navigate('/')} className="btn btn-secondary">
              Voir le site
            </button>
            <button onClick={handleLogout} className="btn btn-primary">
              Déconnexion
            </button>
          </div>
        </div>
      </nav>

      <section className="admin-dashboard">
        <div className="container">
          <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '2rem'}}>
            <h1>📚 Gestion des Articles</h1>
            <button 
              onClick={() => navigate('/admin/articles/create')} 
              className="btn btn-primary"
              style={{fontSize: '16px', padding: '12px 24px'}}
            >
              ➕ Créer un Article
            </button>
          </div>
          
          <div className="admin-stats">
            <div className="stat-card">
              <div className="stat-number">{articles.length}</div>
              <div className="stat-label">Total Articles</div>
            </div>
            {categories.slice(1).map(cat => {
              const count = articles.filter(a => a.category === cat).length;
              return (
                <div key={cat} className="stat-card">
                  <div className="stat-number">{count}</div>
                  <div className="stat-label">{cat}</div>
                </div>
              );
            })}
          </div>

          <div className="admin-filters">
            <h3>Filtrer par catégorie :</h3>
            <div className="category-filters">
              {categories.map((category) => (
                <button
                  key={category}
                  onClick={() => setSelectedCategory(category)}
                  className={`category-btn ${selectedCategory === category ? 'active' : ''}`}
                >
                  {category}
                </button>
              ))}
            </div>
          </div>

          {loading ? (
            <div className="loading-state">Chargement...</div>
          ) : (
            <div className="admin-articles-table">
              <table>
                <thead>
                  <tr>
                    <th>Statut</th>
                    <th>Titre</th>
                    <th>Catégorie</th>
                    <th>Contenu</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredArticles.map((article) => (
                    <tr key={article.id} style={{opacity: article.is_active === false ? 0.5 : 1}}>
                      <td>
                        <button
                          onClick={() => toggleArticleStatus(article.id, article.is_active)}
                          className={`btn btn-small ${article.is_active !== false ? 'btn-success' : 'btn-warning'}`}
                          style={{
                            padding: '4px 8px',
                            fontSize: '12px',
                            minWidth: '80px'
                          }}
                        >
                          {article.is_active !== false ? '✅ Actif' : '⏸️ Inactif'}
                        </button>
                      </td>
                      <td>
                        <strong>{article.title}</strong>
                        {article.is_active === false && <span style={{color: '#f59e0b', marginLeft: '8px', fontSize: '12px'}}>(masqué)</span>}
                      </td>
                      <td>
                        <span className="table-category">{article.category}</span>
                      </td>
                      <td>
                        <span className="content-length">
                          {article.content ? `${article.content.length} caractères` : 'Vide'}
                        </span>
                      </td>
                      <td>
                        <div style={{display: 'flex', gap: '8px', flexWrap: 'wrap'}}>
                          <button
                            onClick={() => navigate(`/admin/articles/edit/${article.slug}`)}
                            className="btn btn-small btn-primary"
                          >
                            ✏️ Éditer
                          </button>
                          <button
                            onClick={() => window.open(`/blog/${article.slug}`, '_blank')}
                            className="btn btn-small btn-secondary"
                            style={{background: '#6b7280', color: 'white'}}
                          >
                            👁️ Voir
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </section>
    </div>
  );
}

export default AdminDashboard;
